const classPopinVisible = 'popin--visible';

// remove popins that have already been shown, based on cookie
$('.popins .popin').each(function () {
    let $popin = $(this),
        popinID = $popin.data('popin-id');

    if (typeof popinID === 'undefined' || '' === popinID) {
        return false;
    }

    // check if cookie exists for this popin - if so, dont show
    if ($popin.hasClass('popin--has-cookie')) {
        let cookieHash = 'popin_'+ $popin.data('cookie-hash');

        if (Cookies.get(cookieHash)) {
            $popin.remove();
        }
    }
});

// show popins on desktop
if (viewport().width > 767) {
    setTimeout(function () {
        $($('.popins .popin').get().reverse()).each(function (i) {
            let $popin = $(this),
            delay = $popin.data('popin-delay');

            if (typeof delay == 'undefined') {
                delay = 0;
            }

            setTimeout(function () {
                $popin.addClass(classPopinVisible);
            }, delay);
        });
    }, 500);
}

// hide popin on close button click
$('.popin__close').on('click', function() {
    let $popin = $(this).closest('.popin'); 

    $popin.removeClass(classPopinVisible);

    setTimeout(function () {
        $popin.remove();
    }, 300);

    // set cookie if needed
    if ($popin.hasClass('popin--has-cookie')) {
        let duration = $popin.data('cookie-duration'),
            cookieHash = 'popin_'+ $popin.data('cookie-hash'); // based on popin content, so if content changes popin will be shown again

        if (typeof duration !== 'undefined' && typeof cookieHash !== 'undefined') {
            setCookie(cookieHash, 1, duration);
        }
    }
});

// set cookie when a .btn element inside popin is clicked
$('.popin .btn').on('click', function() {
    let $popin = $(this).closest('.popin');

    if ($popin.hasClass('popin--has-cookie')) {
        let duration = $popin.data('cookie-duration'),
            cookieHash = 'popin_'+ $popin.data('cookie-hash'); // based on popin content, so if content changes popin will be shown again

        if (typeof duration !== 'undefined' && typeof cookieHash !== 'undefined') {
            setCookie(cookieHash, 1, duration);
        }
    }
});